import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { linkCrowdCell } from '@api/manageCrowdCells';

import { ILinkCrowdCellDTO } from '@interfaces/crowdcell/dto/linkSiteDTO';

import { ESnackbarTypes } from '@enums/common';

import { CROWDCELLS, LINK_SITE_TO_CROWDCELL, SITE_PROFILE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateLinkCrowdCell = (onSettledCallbacks?: Array<() => void>) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: handleLinkCrowdCell,
		isLoading: isLoadingLinkCrowdCell,
	} = useMutation<ILinkCrowdCellDTO>({
		mutationKey: [LINK_SITE_TO_CROWDCELL],
		mutationFn: linkCrowdCell,
		onSuccess: () => {
			if (onSettledCallbacks?.length) {
				onSettledCallbacks.forEach((callback) => callback());
			}

			dispatch(setSnackbar({
				message: responseMessages.linkCrowdCellToSite,
				type: ESnackbarTypes.success,
			}));

			return [
				queryClient.invalidateQueries([CROWDCELLS]),
				queryClient.invalidateQueries([SITE_PROFILE]),
			];
		},
	});

	return {
		handleLinkCrowdCell,
		isLoadingLinkCrowdCell,
	};
};
